export default class Payments {

  static can_test_payments = (id) => {
    return true;
    // return [1, 106, 1130, 1131, 33942, 35109, 26, 27, 8978, 33761].indexOf(id) > -1;
  };
}
